module.exports = __webpack_public_path__ + "media/images/rodapé-e2f61318d259b7d668f79b33ef4f91f2.jpeg";